import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import { useState } from "react";

const DesconcluirModal = ({ open, onClose, onConfirm }) => {
  const [razon, setRazon] = useState("");

  const handleClose = () => {
    onClose();
    setRazon("");
  };

  const handleConfirm = () => {
    onConfirm(razon);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Razón</DialogTitle>
      <DialogContent>
        <div>
          <label className="form-label">
            Ingrese el motivo de la desconclusion:
          </label>
          <textarea
            placeholder="Motivo..."
            value={razon}
            onChange={(e) => {
              setRazon(e.target.value);
            }}
            rows="4"
            required
          />
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Aceptar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DesconcluirModal;
